export const ProjectionMode = {
  MAX: 0,
  MIN: 1,
  AVERAGE: 2,
};

export default {
  ProjectionMode,
};
